import Vue from 'vue'
import Vuetify from 'vuetify/lib'
import th from 'vuetify/es5/locale/th'

Vue.use(Vuetify)

export default new Vuetify({
  theme: {
    themes: {
      light: {
        primary: '#01BB00',
        secondary: '#F05B25',
        success: '#29CD8A',
        warning: '#FFAB00',
        error: '#EF2956'
      }
    }
  },
  lang: {
    locales: { th },
    current: 'th'
  }
})
